import Cookies from "js-cookie";

import { toast } from "@/components/app/app-toast";

import { useAlertStore } from "@/stores/alert-store";
import { useEventTriggerStore } from "@/stores/event-trigger-store";
import { useUserStore } from "@/stores/userStore";

// API 타입들 export
export * from "./types";

// API 유틸리티 함수들 export
export * from "./utils";

// API 함수들 export
export * from "./about";
export * from "./user";
const TIMEOUTVALUE = 100000;
// API 상수들
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "auth/signin",
    LOGOUT: "auth/signout",
    REFRESH: "/api/auth/refresh",
    RESET_REQUEST: "auth/reset-request", // 이메일로 인증코드 보내기
    RESET_CONFIRM: "auth/reset-confirm", // 이메일 인증코드 확인
    RESET_PASSWORD: "auth/reset-password", // 새로운 비밀번호 설정
    CHANGE_PASSWORD: "auth/change-password",
    ADD_USER: "auth/add-user",
    ONBOARD: "auth/onboard",
    SIGNUP: "auth/signup", // 회원가입
    SIGNUP_CODE_REQUEST: "auth/signup-code-request", // 회원가입 이메일 인증코드 발송
    SIGNUP_CODE_CONFIRM: "auth/signup-code-confirm", // 회원가입 이메일 인증코드 확인
  },
  MEDIA: {
    LIST: "adp/get-media-list",
  },
  FAVORITE: {
    GET_FAVORITE_LIST: "adp/get-favorite-list",
    SAVE_FAVORITE: "adp/save-favorite",
    DELETE_FAVORITE: "adp/delete-favorite",
  },
  PAYKCP: {
    PAYKCP_VOUCHER: "payuse-voucher",
    PAYGET_REG_CARD_LIST: "pay/get-reg-card-list",
    PAYGET_REG_CARD_DEFAULT: "pay/set-reg-card-default",
    PAYGET_DELETE_REG_CARD: "pay/delete-reg-card",
    COMPLETE_PAY: "pay/kcp/complete-pay",
    GET_PAY_CODE: "pay/kcp/get-pay-code",
    GET_AUTOPAY_CODE: "pay/kcp/get-autopay-code",
    GET_PAY_MODE: "pay/kcp/get-pay-mode",
    COMPLETE_AUTOPAY: "pay/kcp/complete-autopay",
    PAYGET_REG_AUTOPAY_RETURL: "pay/kcp/get-autopay-returl",
  },
  MENU: {
    MENU_VOUCHER: "menu/menu_voucher",
    MENU_VOUCHER_ADMIN: "menu/menu_voucher_admin",
    MENU_VOUCHER_DETAIL: "menu/menu_voucher_detail",
    MENU_VOUCHER_UPDATE: "menu/menu_voucher_update",
    MENU_VOUCHER_REVOKE: "menu/menu_voucher_revoke",
    MENU_USER_LIST: "menu/menu-user-list",
    MENU_ADMIN_LIST: "menu/menu-admin-list",
    MENU_PAY_LIST: "menu/menu_pay_list",
    MENU_CREDIT: "menu/menu_credit",
    MENU_SALES: "menu/menu_sales",
    MENU_PAY: "menu/menu_pay",
    PART_LIST: "menu/part-list",
    ADD_PART: "menu/add-part",
    MENU_CREDIT_UPDATE: "menu/menu_credit_update",
    UPDATE_PART: "menu/update-part",
    DELETE_PART: "menu/delete-part",
    PART_GROUP_LIST: "menu/part-group-list",
    UPDATE_GROUP_PART_BATCH: "menu/update-group-part-batch",
    GET_PAY_INFO: "menu/get-pay-info",
    CANCEL_PAY_BY_USER: "menu/cancel-pay-by-user",
    SET_REG_CARD_DEFAULT: "menu/set-reg-card-default",
    DELETE_REG_CARD: "menu/delete-reg-card",
    GET_MENU_LIST: "menu/menu_docs",
    FEEDBACK: "menu/feedback",
  },
  USER: {
    ME: "/api/user/me",
    LIST: "/api/users",
    BY_ID: (id: string) => `/api/user/${id}`,
    UPDATE_ROLE: (id: string) => `/api/user/${id}/role`,
    GET_USER_LIST: "user/get-user-list-v2",
    GET_USER: "user/get-user",
    UPDATE_USER: "user/update-user",
    GET_USER_BY_ID: "user/get-user-by-id", // 지정된 유저에 대한  권한 변경
    RESET_PASSWORD: "user/reset-password", // 지정된 유저에 대한 정보 리턴
    CHANGE_ROLE: "user/change-role", // 지정한 유저에 대한 비밀번호 초기화
    UPDATE_SUB_USER: "user/update-sub-user", // 상태 활성화 토글
    GET_USER_GROUP: "user/get-user-group", // 사용자 그룹 크레딧 조회
    RESEND_BOARDING_EMAIL: "user/resend-boarding-email", // 초대 메일 재발송
    DELETE_USER: "user/delete-user", // 초대 사용자 삭제
    WITHDRAW_ME: "user/withdraw-me",
  },
  ABOUT: {
    DATA: "/api/about",
  },
  CREDIT: {
    DATA: "credit",
    CREATE_AND_REDEEM_VOUCHER: "credits/admin/create-and-redeem-voucher",
    REDEEM_VOUCHER_ME: "credits/redeem-voucher/me",
  },
  RESIZE: {
    BY_STATUS: (status: "등록완료" | "등록실패" | "만료") => `resize?status=${status}`,
  },
  // 문서 관련
  DOC: {
    // 소재 문서 리스트 불러오기\ CREATE: "adp/create-doc",
    CREATE: "adp/create-doc",
    CREATE_DOC: "adp/create-doc-v2",
    CREATE_DOC_V3: "adp/create-doc-v3",
    PSD_TO_PNG: "adp/psd2png",
    INIT: "adp/init-doc",
    INIT_V3: "adp/init-doc-v3",
    REINIT: "adp/reinit-doc",
    INITMEDIA: "adp/init-media",
    UPDATE: "adp/update-doc",
    CHECK_UPDATE: "adp/check-update-doc",
    CHECK_DOC_COLOR: "adp/check-doc-color",
    UPDATE_DOC_COLOR: "adp/update-doc-color",
    REUPDATE: "adp/re-update-doc",
    GET_LIST: "adp/get-doc-list",
    GET: "adp/get-doc",
    COMMENT: "adp/comment-doc",
    DOWNLOAD: "adp/download-doc",
    DOWNLOAD_LIST: "adp/get-download-list",
    DOWNLOAD_CHECK: "adp/download-check",
    POLL: "adp/poll-data",
    POLL_DOWNLOAD: "adp/poll-download",
    GET_MEDIA_LIST_BY_DOC: "adp/get-media-list-by-doc",
    RENAME_DOC: "adp/rename-doc",
    LAYER: "adp/get-layout",
    UPDATE_LAYOUT: "adp/update-layout",
    ROLLBACK_LAYOUT: "adp/rollback-layout",
  },
  EVENT: {
    APP_READ_EVENT: "app/read-event",
    APP_POLL_EVENT: "app/poll-event",
    APP_DELETE_EVENT: "app/delete-event",
    APP_DELETE_EVENT_ALL: "app/delete-event-all",
  },
  FEEDBACK: {
    LIST: "menu/menu-feedback",
    ANSWER: "menu/feedback-answer",
  },
  PLANS: {
    PLANS_AVAILABLE: "plans/available",
  },
} as const;

// API 설정
export const API_CONFIG = {
  BASE_URL: process.env.NEXT_APP_API_URL || "/api",
  TIMEOUT: TIMEOUTVALUE,
  RETRIES: 3,
  DEFAULT_HEADERS: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
} as const;

// 공통 fetch 옵션 타입
export interface FetchOptions {
  url: string;
  method?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
  headers?: Record<string, string>;
  body?: unknown;
  signal?: AbortSignal;
  timeout?: number;
  responseType?: "json" | "blob" | "text";
}

// API 에러 타입
export interface ApiError extends Error {
  status?: number;
  handled?: boolean;
  detail?: { title?: string; message?: string; code?: string };
}

// 에러 생성 헬퍼 함수
function createApiError(
  message: string,
  status: number,
  handled: boolean = false,
  detail?: { title?: string; message?: string; code?: string }
): ApiError {
  const error = new Error(message) as ApiError;
  error.status = status;
  error.handled = handled;
  error.detail = detail;
  return error;
}

// 클라이언트용 공통 fetch 함수
export async function fetchRequest<T>({
  url,
  method = "GET",
  headers = {},
  body,
  responseType = "json",
}: FetchOptions): Promise<T> {
  const baseURL = API_CONFIG.BASE_URL;
  const token = Cookies.get("accessToken");

  // FormData인 경우 Content-Type을 설정하지 않음 (브라우저가 자동으로 multipart/form-data 설정)
  const isFormData = body instanceof FormData;
  const defaultHeaders = isFormData
    ? {} // FormData는 기본 헤더 제외
    : API_CONFIG.DEFAULT_HEADERS;

  // body 처리: FormData는 그대로, 일반 객체는 JSON.stringify
  let requestBody: BodyInit | undefined;
  if (isFormData) {
    requestBody = body;
  } else if (body) {
    requestBody = JSON.stringify(body);
  }

  const requestOptions: RequestInit = {
    method,
    headers: {
      ...defaultHeaders,
      ...headers,
      ...(token && { Authorization: `Bearer ${token}` }),
      "X-NAI-TIMESTAMP": Date.now().toString(),
      "Cache-Control": "no-cache",
    },
    body: requestBody,
  };

  const controller = new AbortController();
  const id = setTimeout(() => {
    controller.abort();
  }, 20000);

  try {
    const response = await fetch(`${baseURL}/${url}`, {
      ...requestOptions,
      signal: controller.signal,
    });

    clearTimeout(id);

    if (!response.ok) {
      const { logout } = useUserStore.getState();
      const { openDialog: openAlert } = useAlertStore.getState();

      const errorData = await response.json().catch(() => ({}));

      // detail이 없거나 object가 아닌 경우 기본 에러 처리
      const hasDetailCode = errorData.detail && typeof errorData.detail === "object";

      if (!hasDetailCode) {
        const errorMessage = errorData.message || `HTTP ${response.status}: ${response.statusText}`;
        throw createApiError(errorMessage, response.status, false);
      }

      const code = errorData.detail.code;

      // 상태 코드별 에러 처리
      if (response.status === 400) {
        switch (code) {
          case "APP.BAD_REQUEST": {
            toast({
              type: "error",
              title: "오류",
              description: "일시적인 오류가 발생했습니다. 다시 시도해 주세요.",
            });
            throw createApiError(
              "일시적인 오류가 발생했습니다. 다시 시도해 주세요.",
              response.status,
              true
            );
          }
          case "APP.INVALID_VOUCHER_STATE": {
            openAlert({
              type: "warning",
              title: "사용 이력이 발생하여 회수가 불가합니다.",
              description: "사용하지 않은 경우에만 회수가 가능합니다.",
            });
            throw createApiError("사용 이력이 발생하여 회수가 불가합니다.", response.status, true);
          }

          case "APP.INVALID_VOUCHER_STATE_UPDATE": {
            openAlert({
              type: "warning",
              title: "사용 이력이 발생하여 회수가 불가합니다.",
              description: "사용하지 않은 경우에만 회수가 가능합니다.",
            });
            throw createApiError("사용 이력이 발생하여 회수가 불가합니다.", response.status, true);
          }
          case "APP.WITHDRAW_FAIL_EXIST_US": {
            openAlert({
              type: "warning",
              title: "사용자 계정이 존재하여 탈퇴가 불가합니다.",
              description: "소속 사용자 1명에게 권한 위임 후 탈퇴가 가능합니다.",
            });
            throw createApiError(
              "사용자 계정이 존재하여 탈퇴가 불가합니다. 소속 사용자 1명에게 권한 위임 후 탈퇴가 가능합니다",
              response.status,
              true
            );
          }

          case "APP.WITHDRAW_FAIL_NOT_EXIST_A": {
            openAlert({
              type: "warning",
              title: "관리자 권한은 최소 1명 이상이어야 합니다.",
              description: "다른 사용자의 권한 변경 후 탈퇴해 주세요.",
            });
            throw createApiError(
              "관리자 권한은 최소 1명 이상이어야 합니다. 다른 사용자의 권한 변경 후 탈퇴해 주세요.",
              response.status,
              true
            );
          }

          case "APP.FAIL_ADDUSER_EXIST": {
            openAlert({
              type: "warning",
              title: "이미 등록된 사용자 입니다.",
              description: "",
            });
            throw createApiError("이미 등록된 사용자 입니다.", response.status, true);
          }

          case "APP.FAIL_ADDUSER_DELETED": {
            openAlert({
              type: "warning",
              title: "회원 탈퇴 후 7일이 경과하지 않아 \n 사용자 추가가 불가합니다.",
              description: "",
            });
            throw createApiError(
              "회원 탈퇴 후 7일이 경과하지 않아 사용자 추가가 불가합니다.",
              response.status,
              true
            );
          }

          default: {
            openAlert({
              type: "warning",
              title: "요청 오류",
              description: errorData.detail?.message || "잘못된 요청입니다.",
            });
            throw createApiError(
              errorData.message || `HTTP ${response.status}: ${response.statusText}`,
              response.status,
              true
            );
          }
        }
      } else if (response.status === 401) {
        switch (code) {
          case "AUTH.USER_ONBOARDING_EXPIRED": {
            openAlert({
              type: "warning",
              title: "로그인 기한이 만료되었습니다. ",
              description: "대표사용자에게 계정 발급을 다시 요청해 주세요.",
            });
            throw createApiError(
              "로그인 기한이 만료되었습니다. 대표사용자에게 계정 발급을 다시 요청해 주세요.",
              response.status,
              true
            );
          }

          case "AUTH.USER_NOT_FOUND": {
            openAlert({
              type: "warning",
              title: "회원정보를 찾을 수 없습니다.",
              description: "관리자 또는 대표사용자(또는 고객센터)에게 문의하세요.",
            });
            throw createApiError("회원정보를 찾을 수 없습니다.", response.status, true);
          }

          case "AUTH.USER_SIGNIN_INVALID": {
            openAlert({
              type: "warning",
              title: "이메일 또는 비밀번호가 올바르지 않습니다.",
              description: "다시 로그인해주세요.",
              descriptionSrOnly: true,
            });
            throw createApiError(
              "이메일 또는 비밀번호가 올바르지 않습니다.",
              response.status,
              true
            );
          }

          case "AUTH.USER_EXPIRED": {
            openAlert({
              type: "warning",
              title: "로그인 기한이 만료되었습니다. 대표사용자에게 계정 발급을 다시 요청해 주세요.",
              description: "다시 로그인해주세요.",
              descriptionSrOnly: true,
            });
            throw createApiError(
              "로그인 기한이 만료되었습니다. 대표사용자에게 계정 발급을 다시 요청해 주세요.",
              response.status,
              true
            );
          }

          case "AUTH.USER_SIGNIN_DELETED": {
            openAlert({
              type: "warning",
              title: "탈퇴한 사용자입니다.",
              description: "관리자 또는 대표사용자(또는 고객센터)에게 문의하세요.",
              descriptionSrOnly: true,
            });
            throw createApiError("탈퇴한 사용자입니다.", response.status, true);
          }

          case "AUTH.USER_SIGNIN_INACTIVE": {
            openAlert({
              type: "warning",
              title: "계정이 비활성화되어 있습니다.",
              description: "관리자 또는 대표사용자(또는 고객센터)에 문의해 주세요.",
            });
            throw createApiError("계정이 비활성화되어 있습니다.", response.status, true);
          }

          case "AUTH.USER_INACTIVE": {
            openAlert({
              type: "warning",
              title: "계정이 비활성화 처리되어 로그아웃 처리됩니다.",
              description: "관리자 또는 대표사용자(또는 고객센터)에 문의해주세요.",
              onAction: () => {
                logout();
                window.location.href = "/sign-in";
              },
            });
            throw createApiError(
              "계정이 비활성화 처리되어 로그아웃 처리됩니다.",
              response.status,
              true
            );
          }

          default: {
            openAlert({
              type: "warning",
              title: "로그인 정보가 만료되었거나 확인할 수 없습니다.",
              description: "다시 로그인해 주세요.",
            });
            throw createApiError(
              errorData.message || `HTTP ${response.status}: ${response.statusText}`,
              response.status,
              true
            );
          }
        }
      } else if (response.status === 403) {
        switch (code) {
          case "AUTH.USER_ROLE_CHANGED": {
            openAlert({
              type: "warning",
              title: "권한이 변경되어 로그아웃 처리됩니다.",
              description: "다시 로그인해주세요.",
              onAction: () => {
                logout();
                window.location.href = "/sign-in";
              },
            });
            throw createApiError("권한이 변경되어 로그아웃 처리됩니다.", response.status, true);
          }

          default: {
            openAlert({
              type: "warning",
              title: "이 작업을 수행할 권한이 없습니다.",
              description:
                "권한이 필요하다면 관리자 또는 대표사용자(또는 고객센터)에게 문의해 주세요.",
            });
            throw createApiError(
              errorData.message || `HTTP ${response.status}: ${response.statusText}`,
              response.status,
              true
            );
          }
        }
      } else if (response.status === 404) {
        switch (code) {
          case "APP.INVALID_VOUCHER_CODE": {
            openAlert({
              type: "warning",
              title: "바우처 사용 실패",
              description: "유효하지 않는 바우처 코드를 입력하셨습니다.",
            });
            throw createApiError("유효하지 않는 바우처 코드입니다.", response.status, true);
          }

          default: {
            openAlert({
              type: "warning",
              title: "페이지 오류가 발생했습니다.",
              description: "요청한 리소스(페이지, 파일 등)를 찾을 수 없습니다.",
            });
            throw createApiError(
              errorData.message || `HTTP ${response.status}: ${response.statusText}`,
              response.status,
              true
            );
          }
        }
      } else if (response.status === 500) {
        switch (code) {
          case "APP.SYSTEM_BUSY": {
            openAlert({
              type: "warning",
              title: "시스템 대기중",
              description: "사용자가 많아 서비스가 원활하지 않습니다. 잠시후 다시 시도해 주세요.",
            });
            throw createApiError("시스템 대기중", response.status, true);
          }

          case "APP.ERROR": {
            openAlert({
              type: "warning",
              title: "잠시 후 다시 시도해 주세요.",
              description: "",
            });
            throw createApiError("잠시 후 다시 시도해 주세요.", response.status, true);
          }

          default: {
            openAlert({
              type: "warning",
              title: "서버 오류가 발생했습니다.",
              description: "잠시 후 다시 시도해 주세요.",
            });
            throw createApiError(
              errorData.message || `HTTP ${response.status}: ${response.statusText}`,
              response.status,
              true
            );
          }
        }
      } else {
        throw createApiError(
          errorData.message || `HTTP ${response.status}: ${response.statusText}`,
          response.status,
          false,
          errorData.detail
        );
      }
    }

    let data: T;

    if (responseType === "blob") {
      data = (await response.blob()) as T;
    } else if (responseType === "text") {
      data = (await response.text()) as T;
    } else {
      data = await response.json();
    }

    const pollEventData =
      data && typeof data === "object" ? (data as { ["poll-event"]?: unknown }) : null;

    if (pollEventData?.["poll-event"]) {
      useEventTriggerStore.getState().triggerEventFetch();
    }

    return data;
  } catch (error) {
    clearTimeout(id);

    if (error instanceof Error) {
      throw error;
    }
    throw new Error("Unknown error occurred");
  }
}

// 서버용 공통 fetch 함수 (Next.js 서버 컴포넌트용)
export async function fetchRequestServer<T>({
  url,
  method = "GET",
  headers = {},
  body,
  timeout = TIMEOUTVALUE,
  responseType = "json",
}: Omit<FetchOptions, "signal">): Promise<T> {
  const baseURL = API_CONFIG.BASE_URL;

  // 서버에서 환경 변수에서 토큰 가져오기
  const token = process.env.AUTH_TOKEN || null;

  // FormData인 경우 Content-Type을 설정하지 않음 (브라우저가 자동으로 multipart/form-data 설정)
  const isFormData = body instanceof FormData;
  const defaultHeaders = isFormData
    ? {} // FormData는 기본 헤더 제외
    : API_CONFIG.DEFAULT_HEADERS;

  // body 처리: FormData는 그대로, 일반 객체는 JSON.stringify
  let requestBody: BodyInit | undefined;
  if (isFormData) {
    requestBody = body;
  } else if (body) {
    requestBody = JSON.stringify(body);
  }

  const requestOptions: RequestInit = {
    method,
    headers: {
      ...defaultHeaders,
      ...headers,
      ...(token && { Authorization: `Bearer ${token}` }),
      "X-NAI-TIMESTAMP": Date.now().toString(),
      "Cache-Control": "no-cache",
    },
    body: requestBody,
    signal: AbortSignal.timeout(timeout),
  };

  try {
    const response = await fetch(`${baseURL}/${url}`, requestOptions);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.message || `HTTP ${response.status}: ${response.statusText}`;
      const error = new Error(errorMessage) as Error & {
        detail?: { title: string; message: string };
      };
      if (errorData.detail) {
        error.detail = errorData.detail;
      }
      throw error;
    }

    if (responseType === "blob") {
      return (await response.blob()) as T;
    }

    if (responseType === "text") {
      return (await response.text()) as T;
    }

    return await response.json();
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error("Unknown error occurred");
  }
}

// 클라이언트용 HTTP 메서드별 헬퍼 함수들
export const clientApi = {
  get: <T>(url: string, options?: Omit<FetchOptions, "url" | "method">) =>
    fetchRequest<T>({ ...options, url, method: "GET" }),

  post: <T>(url: string, body?: unknown, options?: Omit<FetchOptions, "url" | "method" | "body">) =>
    fetchRequest<T>({ ...options, url, method: "POST", body }),

  put: <T>(url: string, body?: unknown, options?: Omit<FetchOptions, "url" | "method" | "body">) =>
    fetchRequest<T>({ ...options, url, method: "PUT", body }),

  delete: <T>(url: string, options?: Omit<FetchOptions, "url" | "method">) =>
    fetchRequest<T>({ ...options, url, method: "DELETE" }),

  patch: <T>(
    url: string,
    body?: unknown,
    options?: Omit<FetchOptions, "url" | "method" | "body">
  ) => fetchRequest<T>({ ...options, url, method: "PATCH", body }),
};

// 서버용 HTTP 메서드별 헬퍼 함수들
export const serverApi = {
  get: <T>(url: string, options?: Omit<FetchOptions, "url" | "method" | "signal">) =>
    fetchRequestServer<T>({ ...options, url, method: "GET" }),

  post: <T>(
    url: string,
    body?: unknown,
    options?: Omit<FetchOptions, "url" | "method" | "body" | "signal">
  ) => fetchRequestServer<T>({ ...options, url, method: "POST", body }),

  put: <T>(
    url: string,
    body?: unknown,
    options?: Omit<FetchOptions, "url" | "method" | "body" | "signal">
  ) => fetchRequestServer<T>({ ...options, url, method: "PUT", body }),

  delete: <T>(url: string, options?: Omit<FetchOptions, "url" | "method" | "signal">) =>
    fetchRequestServer<T>({ ...options, url, method: "DELETE" }),

  patch: <T>(
    url: string,
    body?: unknown,
    options?: Omit<FetchOptions, "url" | "method" | "body" | "signal">
  ) => fetchRequestServer<T>({ ...options, url, method: "PATCH", body }),
};
